export default {"src":"/_next/static/media/TEAMS_SELECTED.b6de5644.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};